import { API_URL, API_URL_3 } from "env";
import { useEffect } from "react";

const CallbackLogin = () => {
  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');

      // Verify state
      const savedState = sessionStorage.getItem('google_oauth_state');
      if (state !== savedState) {
        console.error('State mismatch');
        return;
      }

      if (code) {
        try {
          const response = await fetch(`${API_URL_3}/api/v1/google/login`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code, state })
          });

          const data = await response.json();
          if (data.status) {
            localStorage.setItem('token', data.data.access_token);
            window.location.href = '/';
          }
        } catch (error) {
          console.error('Login error:', error);
        }
      }
    };

    handleCallback();
  }, []);

  return <div>Processing Google login...</div>;
};

export default CallbackLogin